/** Maximale Zeichenanzahl für den Titel eines Announcements (siehe shell-service-openapi.yml → maxLength: 255). */
export const TITLE_MAX_LENGTH = 255;
